<template>
  <PartnerListWidget :href="ctaLink" @click="onLinkClick">
    <template #icon>
      <HgIcon icon="MovingBox" size="large" theme="secondary" />
    </template>
    <template #content>
      <span>
        {{ t('integrations.movu.message') }}
        <span :class="$style.cta">{{ ctaAction }}</span>
      </span>
    </template>
  </PartnerListWidget>
</template>

<script lang="ts" setup>
import { HgIcon } from '@smg-real-estate/domus';
import { computed } from 'vue';

import PartnerListWidget from '@/components/PartnerIntegrations/PartnerListWidget/PartnerListWidget.vue';
import { InteractionGoal } from '@/helpers/GTM/GTMParameters';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineOptions({
  name: 'Movu',
});

const emit = defineEmits<{
  trackPartnerLink: [link: string, eventLabel: InteractionGoal];
}>();

const ctaLink = computed((): string => {
  return t('integrations.movu.href');
});
const ctaAction = computed((): string => {
  return t('integrations.movu.action');
});

const onLinkClick = () => {
  emit('trackPartnerLink', ctaLink.value, InteractionGoal.MOVING_CLEANING_QUOTES);
};
</script>
<style lang="scss" module>
@import '@/assets/variables';

.cta {
  color: var(--base-color-link);

  @include font-bold;
}
</style>
